/** Fecha local YYYY-MM-DD sin depender de UTC. */
export function toYmdLocal(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function ymdAddDays(ymd: string, days: number): string {
  const [y, m, d] = ymd.split('-').map((x) => parseInt(x, 10));
  if (!y || !m || !d) return ymd;
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + days);
  return toYmdLocal(dt);
}

/** Último día del mes calendario en curso (local). */
export function ymdFinDeMesLocal(ref: Date = new Date()): string {
  const y = ref.getFullYear();
  const mo = ref.getMonth();
  const last = new Date(y, mo + 1, 0);
  return toYmdLocal(last);
}

/** Parte en N montos enteros COP; la suma = total. */
export function partesIgualesCOP(total: number, n: number): number[] {
  const t = Math.max(0, Math.round(total));
  const k = Math.max(1, Math.min(48, Math.floor(n)));
  if (k === 1) return [t];
  const base = Math.floor(t / k);
  const rem = t - base * k;
  const out: number[] = [];
  for (let i = 0; i < k; i += 1) {
    out.push(base + (i === k - 1 ? rem : 0));
  }
  return out;
}

/**
 * Asigna abono a cuotas en orden; cada cuota tiene tope montoCuota.
 */
export function montoPagadoPorCuota(
  montosCuota: number[],
  abonoTotal: number
): number[] {
  let left = Math.max(0, Math.round(abonoTotal));
  return montosCuota.map((cap) => {
    const c = Math.max(0, Math.round(cap));
    const take = Math.min(left, c);
    left -= take;
    return take;
  });
}

export function estadoCuota(
  montoCuota: number,
  montoPagado: number
): 'pendiente' | 'parcial' | 'pagada' {
  if (montoPagado >= montoCuota && montoCuota > 0) return 'pagada';
  if (montoPagado > 0) return 'parcial';
  return 'pendiente';
}

/** Valores de `creditos.frecuencia` (migración 20260422120000). */
export type FrecuenciaPlanDb = 'unica' | 'semanal' | 'quincenal' | 'mensual';

export function frecuenciaDiasToDb(frecuenciaDias: 7 | 15 | 30): Exclude<FrecuenciaPlanDb, 'unica'> {
  if (frecuenciaDias === 7) return 'semanal';
  if (frecuenciaDias === 15) return 'quincenal';
  return 'mensual';
}

export function fechasPlanCuotas(
  primeraYmd: string,
  n: number,
  frecuenciaDias: 7 | 15 | 30
): string[] {
  const k = Math.max(2, Math.min(48, Math.floor(n)));
  const out: string[] = [];
  let cur = primeraYmd;
  for (let i = 0; i < k; i += 1) {
    out.push(cur);
    if (i < k - 1) cur = ymdAddDays(cur, frecuenciaDias);
  }
  return out;
}
